import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CookieBanner = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-2xl px-4 py-5 sm:px-6 sm:py-6 animate-slide-up"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie Einstellungen"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Shield className="w-8 h-8 text-[#0f2440] flex-shrink-0 hidden sm:block" />
        <div className="flex-1">
          <p className="text-sm text-gray-700 leading-relaxed">
            {t('cookies.text')}{' '}
            <a href="/datenschutz" className="text-blue-600 hover:underline font-medium">
              {t('cookies.learnMore')}
            </a>
          </p>
        </div>
        <div className="flex gap-3 flex-shrink-0 w-full sm:w-auto">
          <button
            onClick={decline}
            data-testid="cookie-decline-btn"
            className="flex-1 sm:flex-initial px-5 py-2.5 text-sm font-medium text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            {t('cookies.decline')}
          </button>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="flex-1 sm:flex-initial px-5 py-2.5 text-sm font-medium text-white bg-[#0f2440] rounded-lg hover:bg-[#1a3a5c] transition-colors"
          >
            {t('cookies.accept')}
          </button>
        </div>
        <button
          onClick={decline}
          data-testid="cookie-close-btn"
          className="absolute top-3 right-3 sm:hidden text-gray-400 hover:text-gray-600"
          aria-label="Schliessen"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
